import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { Badge } from './ui/badge';
import { HelpCircle } from 'lucide-react';

export const FAQ = () => {
  const faqs = [
    {
      question: 'How long does company registration take?',
      answer:
        'Private Limited and LLP registration typically takes 7-15 working days, depending on government processing and document verification. We handle everything from name approval to certificate delivery.',
    },
    {
      question: 'What documents are required for GST registration?',
      answer:
        'For GST registration, you need: PAN card, Aadhaar card, business address proof, bank account details, and photographs. We guide you through the entire documentation process.',
    },
    {
      question: 'Is Startup India certificate mandatory for startups?',
      answer:
        'No, it is not mandatory but highly recommended. It provides tax exemptions for 3 years, IPR benefits, easier compliance, and access to government schemes and funding opportunities.',
    },
    {
      question: 'How much does trademark registration cost?',
      answer:
        'Trademark registration costs vary based on class and type. We offer competitive pricing with complete support including search, filing, objection handling, and registration certificate.',
    },
    {
      question: 'Can I get a business loan without collateral?',
      answer:
        'Yes! We help you get unsecured business loans, MUDRA loans, and CGTMSE loans without collateral. Loan amount depends on your business profile, turnover, and credit score.',
    },
    {
      question: 'Do you provide services outside Gujarat?',
      answer:
        'Yes, absolutely! We provide PAN-India services for all types of business registrations, licenses, and compliance. Our digital process makes it easy to serve clients anywhere in India.',
    },
    {
      question: 'What is the cost of ISO certification?',
      answer:
        'ISO certification cost depends on the type (9001, 14001, 22000, etc.), company size, and scope. We offer competitive packages with complete documentation support and audit preparation.',
    },
    {
      question: 'How do I contact for free consultation?',
      answer:
        'You can call us at 9316085383, WhatsApp us, email at Neelesh@utkarshudyam.com, or fill the contact form on our website. We provide free consultation and eligibility check.',
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <Badge className="mb-4 bg-[#0A2463] text-white px-4 py-2">
            <HelpCircle className="inline mr-2" size={16} />
            FAQ
          </Badge>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A2463] mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Got questions? We've got answers!
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl p-8">
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, index) => (
                <AccordionItem
                  key={index}
                  value={`faq-${index}`}
                  className="border-b border-gray-200 last:border-b-0"
                >
                  <AccordionTrigger className="text-left hover:no-underline py-6 group">
                    <div className="flex items-start gap-4 w-full">
                      <div className="w-8 h-8 bg-gradient-to-br from-[#0A2463] to-[#247BA0] rounded-full flex items-center justify-center flex-shrink-0 text-white font-bold text-sm">
                        {index + 1}
                      </div>
                      <span className="text-lg font-semibold text-[#0A2463] group-hover:text-[#247BA0] transition-colors pr-4">
                        {faq.question}
                      </span>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="pt-2 pb-6">
                    <div className="pl-12">
                      <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                    </div>
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};
